import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import GenericTable from "../../GenericTable/GenericTable";
import TableToolbar from "../../GenericTable/TableToolbar";
import WorkflowSidebar from "../../workflowActions/WorkflowSidebar";
import { enhancePlusColumns } from "./enhancePlusWorkflow.data";
import { mockFiles } from "../../SelectFilesMenu/mockFiles.data";
import EnhancePlusFilterModal from "./EnhancePlusFilter/EnhancePlusFilterModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getEnhancePlusWorkflowData,
  REQUEST_STATUS,
  initialPayload,
  resetEnhancePlusPayload,
  exportEnhancePlusWorkflowCSV,
  updatedEnhancePlusPayload,
} from "./EnhancePlusWorkflowSlice";
import { cleanJoin, downloadBlob } from "../../../web-workflow/utils/util";
import {
  getEnhanceAuditResults,
  getEnhancePlusFlags,
  getEnhanceWorkflowEpisodeDetails,
  resetEpisodeReviewData,
  unassignEpisode,
} from "../EnhanceWorkflow/EnhanceWorkflowSlice";
import EpisodeReview from "../EpisodeReview/EpisodeReview";
import { toast } from "react-toastify";
import SelectFilesMenu from "../../SelectFilesMenu/SelectFilesMenu";
import { getSelectedAuditedFilesMenuData,
  setSelectedFileIds,
  clearSelectedFileIds,
 } from "../../SelectFilesMenu/SelectFilesMenuSlice";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { useNavigate, useParams } from "react-router-dom";

export default function EnhancePlusWorkflow({ activeModule, onModuleChange }) {
  const [sidebarSelected, setSidebarSelected] = useState("");
  const [search, setSearch] = useState("");
  // const [selectedFileIds, setSelectedFileIds] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [version, setVersion] = useState("Version");
  const [selectedRows, setSelectedRows] = useState([]);
  const [isRecalledView, setIsRecalledView] = useState(false);
  const [isUnassignedView, setIsUnassignedView] = useState(false);
   const [isSelectAll, setIsSelectAll] = useState(false);
  const [view, setView] = useState("list");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedEpisode, setSelectedEpisode] = useState(null);
  const currentUserId = sessionStorage.getItem("userId");
  const { payload, response } = useSelector(
    (state) => state.enhancePlusWorkflow,
  );
  const [searchType, setSearchType] = useState("episode");
  const { episodeId } = useParams();
  const [filesAnchor, setFilesAnchor] = useState(null);
  const [auditedFilesPage, setAuditedFilesPage] = useState(1);
  const {
    episodeDetails,
    plusFlags,
    auditResults,
    payload: enhancePayload,
  } = useSelector((state) => state.codeEnhance);
  const { data, status, hasMore } = useSelector(
    (state) => state.selectedAuditedFiles.files,
  );
   const selectedFileIds = useSelector(
   (state) => state.selectedAuditedFiles.selectedFileIds,
 );
  const tableLoading = response.status === REQUEST_STATUS.LOADING;
  const apiEpisodes = response?.data?.data?.episodes ?? [];
  const [isDownloading, setIsDownloading] = useState(false);
  const [filterResetKey, setFilterResetKey] = useState(0);
  const [pageSizeReady, setPageSizeReady] = useState(false);
  // console.log(apiEpisodes, "apiEpisodes");
  const isFirstRender = useRef(true);         
const previousPayloadRef = useRef(null); 
  const enhancePlusRows = apiEpisodes.map((item) => ({
    codeEnhancePriority: item.code_enhance_priority,
    priorityValue: item.priority_value,
    hcpLineId: item.hcp_line_id,
    episodeId: item.episode_id,
    admissionDate: item.admission_date,
    separationDate: item.separation_date,
    los: item.los,
    id: item.hcp_line_id,
    speciality: item.speciality,
    actualDrg: item.actual_drg,
    predictedDrg1: item.predicted_drg1,
    predictedDrg2: item.predicted_drg2,
    drgVersion: item.drg_version,
    actualReimbursement: item.actual_reimbursement,
    predictedReimbursement1: item.predicted_reimbursement1,
    predictedReimbursement2: item.predicted_reimbursement2,
    principalDiagnosis: item.principal_diagnosis,
    principalProcedureCode: cleanJoin(item.principal_procedure_code),
    auditStatus: item.status,
    delta1: item.delta1,
    delta2: item.delta2,
    auditRuleFlaggedStatus: item.audit_rule_flagged_status,
    auditRuleRefNo: item.audit_rule_reference_no?.join(", "),
    auditShortDescription: item.short_description?.join(", ") || "",
    healthFund: item.health_fund_identifier,
    age: item.age,
    predictedDrg1Path: item.predicted_drg1_path,
    predictedDrg2Path: item.predicted_drg2_path,
    mrn:item.medical_record_number,
    isDrgDifferent: item.is_drg_different ? "Yes" : "No",
    assignedTo:item.assigned_to_user_name
  }));

  const pagination = response?.data?.data || {};
  const currentPage = (pagination.page_number || 1) - 1;
  const totalPages = pagination.total_pages || 1;
const FILTER_BOOKKEEPING_KEYS = [
  "page_number",
  "page_size",
  "unassigned_page",
  "is_flagged",
  "sort_by",
  "sort_order",
  "is_global", 
  "recall",
];
  // NEW — has the user made a selection that should trigger a fetch?
  const hasSelection = payload.header_id.length > 0 && Boolean(payload.version);
  const files = data.map((item) => ({
    id: item.header_id,
    fileName: item.file_name?.join(", ") || "",
    dateRange: `${item.start_date} - ${item.end_date}`,
    loadId: item.load_id,
    total_records: item.total_records
  }));
  const hasActiveFilters = Object.entries(payload).some(([key, value]) => {
  if (FILTER_BOOKKEEPING_KEYS.includes(key)) return false;
  if (value === undefined || value === null || value === "") return false;
  if (Array.isArray(value) && value.length === 0) return false;
  if (typeof value === "boolean") return false;
  return true;
});
  const selectedFileNames = files
    .filter((file) => selectedFileIds.includes(file.id))
    .map((file) => file.fileName);

useEffect(() => {
  // if (!hasSelection) return;
  if (!pageSizeReady) return;

  if (isFirstRender.current) {
    isFirstRender.current = false;
    dispatch(getEnhancePlusWorkflowData(payload));
    previousPayloadRef.current = payload;
    return;
  }
 

  const payloadChanged =
    JSON.stringify(previousPayloadRef.current) !== JSON.stringify(payload);

  if (payloadChanged) {
    dispatch(getEnhancePlusWorkflowData(payload));
    previousPayloadRef.current = payload;
  }
}, [dispatch, payload, pageSizeReady]);

  // const filteredRows = search
  //   ? enhancePlusRows.filter((r) =>
  //       r.episodeId?.toLowerCase().includes(search.toLowerCase()),
  //     )
  //   : enhancePlusRows;
useEffect(() => {
  if (!episodeId) {
    setView("list");
    setSelectedEpisode(null);
    return;
  }

  setSelectedEpisode({ hcpLineId: episodeId });
  dispatch(getEnhanceWorkflowEpisodeDetails(episodeId));
  dispatch(getEnhancePlusFlags(episodeId));
  dispatch(getEnhanceAuditResults(episodeId));
  setView("review");
}, [episodeId, dispatch]);
  const handleGlobalSearch = (value,type="episode") => {
    setSearch(value);
  setSearchType(type); 
    dispatch(
      updatedEnhancePlusPayload({
        episode_id: type === "episode" && value ? [value] : [],
        medical_record_number: type === "mrn" && value ? [value] : [],
        is_global: Boolean(value),
        page_number: 1,
      }),
    );
  };

  const handleSortChange = ({ field, order }) => {
    dispatch(
      updatedEnhancePlusPayload({
        sort_by: field,
        sort_order: order.toUpperCase(),
        page_number: 1,
      }),
    );
  };

  const handlePageChange = (page) => {
    dispatch(updatedEnhancePlusPayload({ page_number: page + 1 }));
  };
const handlePageSizeChange = (newSize) => {
  setPageSizeReady(true);
  if (newSize === payload.page_size) return;
  dispatch(updatedEnhancePlusPayload({ page_size: newSize, page_number: 1 }));
};

  const handleFilesApply = (ids) => {
    // setSelectedFileIds(ids);
    dispatch(setSelectedFileIds(ids));
    dispatch(
      updatedEnhancePlusPayload({
        header_id: ids,
        page_number: 1,
      }),
    );
  };

  const versionMap = {
    "Version 10": "10",
    "Version 11": "11",
    "Version 12": "12",
    "Version 6": "6",
    "Version 8": "8",
  };
  const handleOpenFilesMenu = (e) => {
    setFilesAnchor(e.currentTarget);
    setAuditedFilesPage(1);
    dispatch(getSelectedAuditedFilesMenuData(1));
  };

  const handleLoadMoreFiles = () => {
    if (status === REQUEST_STATUS.LOADING || !hasMore) return;
    const nextPage = auditedFilesPage + 1;
    setAuditedFilesPage(nextPage);
    dispatch(getSelectedAuditedFilesMenuData(nextPage));
  };
  const handleVersionChange = (value) => {
    setVersion(value);
    dispatch(
      updatedEnhancePlusPayload({
        version: versionMap[value] || value,
        page_number: 1,
      }),
    );
  };
  const handleEnhancePlusRefresh = () => {
    // setSelectedFileIds([]);
    dispatch(clearSelectedFileIds());
    setVersion("Version");
    setSearch("");
    dispatch(resetEnhancePlusPayload());
    dispatch(getEnhancePlusWorkflowData(initialPayload));
    setFilterResetKey((k) => k + 1);
  };
  useEffect(() => {
  if (selectedFileIds.length === 0) return;
  dispatch(
    updatedEnhancePlusPayload({
      header_id: selectedFileIds,
      page_number: 1,
    }),
  );
}, [selectedFileIds]);
  const handleDownload = async () => {
    const { page_number, page_size, ...exportPayload } = payload;
    setIsDownloading(true);

    try {
      const response = await dispatch(
        exportEnhancePlusWorkflowCSV(exportPayload),
      ).unwrap();

      console.log(response);

      const fileUrl = response?.data?.file_url;
      const queryMessage = response?.data?.message;
      const fileName = response?.data?.file_name || "auditfile.csv";

      toast.success(queryMessage);

      if (fileUrl) {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.log("File URL not found in response");
      }
    } catch (err) {
      console.error("Download error:", err);
      toast.error(err?.message || err || "Failed to export CSV");
    } finally {
      setIsDownloading(false);
    }
  };
  // const handleDownload = async () => {
  //   const { page_number, page_size, ...exportPayload } = payload;
  //   setIsDownloading(true);
  //   try {
  //     const response = await dispatch(
  //       exportEnhancePlusWorkflowCSV(exportPayload),
  //     ).unwrap();
  //     const fileUrl = response?.download_url;
  //     const Querymessage = response?.message;
  //     toast.success(Querymessage);
  //     if (fileUrl) {
  //       // console.log(fileUrl, "acess the url");

  //       const link = document.createElement("a");
  //       link.href = fileUrl;
  //       link.setAttribute("download", "auditfile.csv");
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //     } else {
  //       console.log("file URL not found in reposne");
  //     }
  //   } catch (err) {
  //     console.error("Download error:", err);
  //     toast.error(err?.message || err || "Failed to export CSV");
  //   } finally {
  //     setIsDownloading(false);
  //   }
  // };
  const handleBackToList = () => {
    navigate("/Review-Enhance-Workflow");
    setView("list");
    setSelectedEpisode(null);
    dispatch(resetEpisodeReviewData());
  };
  const handleEpisodeClick = (row) => {
    navigate(`/Review-Enhance-Workflow/${row.hcpLineId}`); 
    setSelectedEpisode(row);
    dispatch(getEnhanceWorkflowEpisodeDetails(row.hcpLineId));
    dispatch(getEnhancePlusFlags(row.hcpLineId));
    dispatch(getEnhanceAuditResults(row.hcpLineId));
    setView("review");
  };
  const handleUnassignConfirm = async (reason) => {
    const hcpLineId = selectedEpisode?.hcpLineId;
    if (!hcpLineId) {
      toast.error("Missing episode reference");
      return;
    }

    try {
      const res = await dispatch(
        unassignEpisode({
          hcp_lines: [hcpLineId],
          unassigned_by: Number(currentUserId),
          unassignment_reason: reason,
          select_all: false,
          user_id: currentUserId,
          filter: enhancePayload,
        }),
      ).unwrap();

      toast.success(res?.message || "Episode unassigned successfully");
      handleBackToList();
    } catch (err) {
      toast.error(err || "Something went wrong");
      throw err;
    }
  };

  if (view === "review") {
    return (
      <Box sx={{ height: "calc(95vh - 14px)", pt: 1.5, bgcolor: "#eef1f5" }}>
        <EpisodeReview
          data={episodeDetails?.data?.data}
          onBack={handleBackToList}
          plusFlags={plusFlags}
          auditResults={auditResults.data}
          onUnassign={handleUnassignConfirm}
          activeModule={activeModule}
          loading={episodeDetails.status === REQUEST_STATUS.LOADING}
          error={
            episodeDetails.status === REQUEST_STATUS.FAILURE
              ? episodeDetails.error || "Something went wrong"
              : null
          }
          hideUnassign={sidebarSelected === "Unassigned Episodes"}
        />
      </Box>
    );
  }
  return (
    <Box
      sx={{
        display: "flex",
        height: "calc(100vh - 12px)",
        overflow: "hidden",
        pt: 1.5,
        bgcolor: "#eef1f5",
      }}
    >
      <WorkflowSidebar selected={sidebarSelected} 
        onSelect={setSidebarSelected}
        setSidebarSelected={setSidebarSelected}
        sidebarSelected= {sidebarSelected}
        selectedRows={selectedRows}
        activeModule={activeModule}
        onModuleChange={onModuleChange}
        isRecalledView={isRecalledView}
        setIsRecalledView={setIsRecalledView}
        isSelectAll={isSelectAll}
        isUnassignedView={isUnassignedView}
         setIsUnassignedView = {setIsUnassignedView}
        onAssignComplete={() => {
          setSelectedRows([]);
          setIsSelectAll(false);
        }}
      
      />

      <Box
        sx={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}
      >
        <TableToolbar
          activeModule={activeModule}
          onModuleChange={onModuleChange}
          onSearch={handleGlobalSearch}
          showVersionInfo={true}
          files={files}
          selectedFileIds={selectedFileIds}
          onFilesApply={handleFilesApply}
          filesLoading={false}
          version={version}
          setVersion={setVersion}
          onVersionChange={handleVersionChange}
          onFilterClick={() => setOpenFilter(true)}
          selectedFileNames={selectedFileNames}
          onRefresh={handleEnhancePlusRefresh}
          onDownload={handleDownload}
          downloadLoading={isDownloading}
         isUnassignedView={isUnassignedView}
         setIsUnassignedView = {setIsUnassignedView}
         isRecalledView={isRecalledView}
        setIsRecalledView={setIsRecalledView}
        setSidebarSelected={setSidebarSelected}
        hasActiveFilters={hasActiveFilters}
        />

        <Box
          sx={{
            flex: 1,
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
          }}
        >
        
            <Box
              sx={{
                "& .MuiPaper-elevation0": {
                  height: "calc(100vh - 110px)",
                },
              }}
            >
              <GenericTable
                columns={enhancePlusColumns}
                rows={enhancePlusRows}
                  selectable={true}
                selectedRows={selectedRows}
                onSelectionChange={setSelectedRows}
                onSelectAllChange={setIsSelectAll}
                loading={tableLoading}
                serverMode
                currentPage={currentPage}
                totalPages={totalPages}
                onSortChange={handleSortChange}
                onPageChange={handlePageChange}
                onRowClick={handleEpisodeClick}
                rowsPerPage={payload.page_size || 10}
                onPageSizeChange={handlePageSizeChange}
                activeModule={activeModule}
               filterResetKey={filterResetKey}
              />
            </Box>
        
        </Box>

        <EnhancePlusFilterModal
          open={openFilter}
          onClose={() => setOpenFilter(false)}
        />
      </Box>
    </Box>
  );
}
